/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import PaymentMethodList from "./PaymentMethodList";
import { connect } from "react-redux";
import { get } from "lodash";
import PropTypes from "prop-types";
import SignupModal from "../Shared/SignupModal";
import MainBackgroundWrapper from "../Shared/MainBackgroundWrapperForMarketplace";
import NavbarRedesignForMarketplace from "../Shared/NavbarRedesignForMarketplace";
import HelmetTag from "../Shared/HelmetTag";

class PaymentMethods extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: null,
      width: window.innerWidth,
      credit_cards: [],
      loading: false,
      error: "",
    };
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
  }

  render() {
    const { width } = this.state;
    const loggedIn = get(this.props, "client.loggedIn", false);

    // Show login modal if not logged in
    if (!loggedIn) {
      return (
        <SignupModal
          isSignin
          next={() => {
            window.location.reload();
          }}
        />
      );
    }

    return (
      <>
        <HelmetTag title="Payment Methods" />
        <NavbarRedesignForMarketplace notBooking showMenu />
        <MainBackgroundWrapper noMarginTop={width < 800} bgImagePath="#fff">
          <div
            style={{
              marginLeft: width >= 1000 ? "15vw" : 0,
              padding: width >= 1000 ? '0' : '80px 16px',
              transition: "margin-left 0.2s",
              minHeight: "calc(100vh - 80px)",
            }}
          >
            <div className={`${width >= 800 ? "max-width-47 p-24" : "mb-48"}`}>
              <div className="contentPrimary">
                {/* Header */}
                <div className="font-weight-bold size-20-28 contentPrimary  p-16 mb-16 top-sticky-80 bg-primary centered">
                  Payment Methods
                </div>

                {/* Payment Methods List */}
                <PaymentMethodList
                  // onSelect={this.handleSelect}
                  // onDelete={this.handleDelete}
                  // onAdd={this.handleAdd}
                  showAdd
                  showDelete
                  showDefault
                  // onDefault={this.handleSaveDefault}
                />
              </div>
            </div>
          </div>
        </MainBackgroundWrapper>
      </>
    );
  }
}

PaymentMethods.propTypes = {
  goBack: PropTypes.func,
};

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps, {})(PaymentMethods);

// Export individual components for reuse
export { default as PaymentMethodList } from "./PaymentMethodList";
export { default as AddNewPaymentMethod } from "./AddNewPaymentMethod";
